
export const GET_DELIVERED_ORDERS_OF_VENUE= 'GET_DELIVERED_ORDERS_OF_VENUE'
export const GET_DELIVERED_ORDERS_OF_VENUE_SUCCESS= 'GET_DELIVERED_ORDERS_OF_VENUE_SUCCESS'
export const GET_DELIVERED_ORDERS_OF_VENUE_ERROR='GET_DELIVERED_ORDERS_OF_VENUE_ERROR'


export const GetDeliveredOrdersOfVenue= (data) => ({
    type: GET_DELIVERED_ORDERS_OF_VENUE,
    payload: data
});
